module.exports = __webpack_public_path__ + "assets/line-3.4d4162d7.svg";